import Typography from 'typography';
const typography = new Typography({
    baseFontSize: '18px',
    baseLineHeight: 1.3,
    headerFontFamily: [
        'Work Sans',
        'Segoe UI',
        'Helvetica',
        'Arial',
        'sans-serif',
    ],
    bodyFontFamily: [
        'Work Sans',
        'Segoe UI',
        'Helvetica',
        'Arial',
        'sans-serif',
    ],
});
export default typography;
